const styles = {
    downloadButton: {
        borderRadius: '20px',
        paddingLeft: '20px',
        paddingRight: '20px',
        minWidth: '190px',
    },
    actionButton: {
        borderRadius: '20px',
        paddingLeft: '20px',
        paddingRight: '20px',
        minWidth: '190px',
        justifyContent: 'space-between',
    },
    mobileDownloadButton: {
        display: 'flex',
        width: '50px',
        height: '50px',
        borderRadius: '50%',
        backgroundColor: '#218bcb',
        justifyContent: 'center',
        alignItems: 'center',
    },
    mobileActionButton: {
        display: 'flex',
        width: '50px',
        height: '50px',
        borderRadius: '50%',
        border: '1px solid #218bcb',
        justifyContent: 'center',
        alignItems: 'center',
    },
}

export default styles
